<template>
	<tr>
		<td>
			<p v-show="!isEditing">{{ gymnast.name }}</p>
			<div class="control" v-if="isEditing">
        <input class="input" type="text" :placeholder="gymnast.name" v-model="gymnastName">
      </div>
		</td>
		<td>			
			<button v-show="!isEditing" class="button is-info is-outlined" @click="editName">	
				<span class="icon is-small">
					<i class="fas fa-edit"></i>
				</span>
			</button>
			<button v-show="isEditing" class="button is-success" @click="submitEdit">	
				<span class="icon is-small">
					<i class="fas fa-check"></i>
				</span>
			</button>
		</td>
		<table-level-cell :level='gymnast.arms' @update:level="val => { updateGymnast('arms', val) }"></table-level-cell>
		<table-level-cell :level='gymnast.legs' @update:level="val => { updateGymnast('legs', val) }"></table-level-cell>
		<table-level-cell :level='gymnast.stomach' @update:level="val => { updateGymnast('stomach', val) }"></table-level-cell>
		<table-level-cell :level='gymnast.back' @update:level="val => { updateGymnast('back', val) }"></table-level-cell>
		<td>
			<button class="button is-danger is-outlined" @click="removeGymnast">
				<span class="icon is-small">
					<i class="fas fa-times"></i>
				</span>
			</button>
		</td>
	</tr>
</template>

<script>
import TableLevelCell from '@/components/TableLevelCell'

export default {
	name: 'gymnast-row',

	data () {
		return {
			isEditing: false,
			gymnastName: this.gymnast.name
		}
	},

	props: {
		gymnast: Object
	},

	components: {
		TableLevelCell
	},

	methods: {
		updateGymnast(section, val) {
			let tempGymnast = this.gymnast
			tempGymnast[section] = val
			this.$emit('update:gymnast', tempGymnast)
		},
		editName () {
			this.isEditing = true
		},
		submitEdit () {
			this.updateGymnast('name', this.gymnastName)
			this.isEditing = false
		},
		removeGymnast () {
			this.$emit('update:remove')
		}
	}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/TableGymnastRow.vue